import axios from "axios";

export const headers = {
  "Content-Type": "application/json",
};

const NotificationService = async (payload) => {
  headers.auth_token = process.env.NEXT_PUBLIC_TOKEN;

  const notificationData = {
    mobile: "+91" + payload?.phone,
  };

  await axios
    .post("/gupshup/whatsapp/lead/store-page", notificationData)
    .then((res) => {
      console.log("Sent Successfully!!", res);
    })
    .catch((error) => {
      console.log("error", error);
    });
};

export default NotificationService;
